import {Address, FullName, Permissible, Phone, Resource, updateResource} from "./common"
import {AnnualIncome, Occupation, OfficerTitle, SourceOfIncome} from "./application"

export type CustomerOfficer = {
	type: "officer"
	id: string
	attributes: {
		fullName: FullName
		ssn: Permissible<string>
		passport: Permissible<string>
		nationality: Permissible<string>
		matriculaConsular: Permissible<string>
		address: Permissible<Address>
		dateOfBirth: Permissible<Date>
		email: Permissible<string>
		phone: Permissible<Phone>
		title?: OfficerTitle
		maskedSSN?: string
		maskedPassport?: string
		maskedMatriculaConsular?: string
		occupation?: Occupation
		sourceOfIncome?: SourceOfIncome
		annualIncome?: AnnualIncome
	}
}

export function isCustomerOfficer(resource: Resource): resource is CustomerOfficer {
	return resource.type === "officer"
}

export type PatchCustomerOfficerAttributes = {
	fullName?: FullName
	title?: OfficerTitle
	ssn?: string
	passport?: string
	nationality?: string | null
	matriculaConsular?: string
	address?: Address
	dateOfBirth?: string
	phone?: Phone
	email?: string
	occupation?: Occupation
	annualIncome?: AnnualIncome
	sourceOfIncome?: SourceOfIncome
}

export async function patchCustomerOfficer(
	accessToken: string,
	customerId: string,
	officerId: string,
	attributes: PatchCustomerOfficerAttributes
) {
	return await updateResource<CustomerOfficer>(`customers/${customerId}/officers/${officerId}`, accessToken, {
		type: "officer",
		attributes,
	})
}
